module.exports = __webpack_public_path__ + "static/media/notificationIcon.34880d4e.webp";